import type { CreditPack } from './billingTypes'

/** DR validates the pill independently of a higher crossed-out reference. */
export function visibleDiscountPercent(pack: CreditPack): number {
  const reference = pack.referenceAmountMinor
  if (reference === undefined || reference <= pack.price.amountMinor || pack.discountPercent <= 0) return 0
  // The decoder admits exact safe integers; no inverse-percent price reconstruction.
  const saving = 100n * (BigInt(reference) - BigInt(pack.price.amountMinor))
  const floor = Number(saving / BigInt(reference))
  const ceil = saving % BigInt(reference) === 0n ? floor : floor + 1
  return pack.discountPercent >= floor && pack.discountPercent <= ceil ? pack.discountPercent : 0
}
